import { memo } from 'react';

export const SkeletonPageLayout = memo(() => (
    <div className="vss-skeleton-page-layout">
        <div className="vss-skeleton-page-layout__device"/>

        <div className="vss-skeleton-page-layout__device"/>

        <div className="vss-skeleton-page-layout__device"/>

        <div className="vss-skeleton-page-layout__device"/>
    </div>
));
